import { createApi } from '@reduxjs/toolkit/query/react';

import { TCredential, TCredentialByType, TCredentialCreate, TCredentialResponse } from '@/types/credentials';

import { baseQueryWithReauth } from './utils';

export const credentialApi = createApi({
  reducerPath: 'credentialApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    createCredential: build.mutation({
      query: (params: TCredentialCreate) => ({
        url: 'credential',
        method: 'POST',
        body: params,
      }),
    }),
    getCredentialsByType: build.query({
      query: (params: TCredentialByType) => ({
        url: 'credential/get-credentials-by-type',
        method: 'POST',
        body: params,
        transformResponse: (response: TCredential[]) => response,
      }),
    }),
    getCredentials: build.query({
      query: (params: { page: number; limit: number; search?: string; types?: string[] }) => ({
        url: 'credential/get-credentials',
        method: 'POST',
        body: {
          ...params,
          search: params.search || '',
        },
      }),
      transformResponse: (response: TCredentialResponse) => response,
    }),
    updateCredential: build.mutation({
      query: (params: TCredentialCreate & { referenceId: string }) => ({
        url: 'credential',
        method: 'PATCH',
        body: params,
      }),
    }),
    deleteCredential: build.mutation({
      query: (referenceId: string) => ({
        url: 'credential',
        method: 'DELETE',
        params: { referenceId },
        responseHandler: (response) => response.text(),
      }),
    }),
    getCredential: build.query({
      query: (referenceId: string) => ({
        url: 'credential',
        method: 'GET',
        params: { referenceId },
      }),
    }),
  }),
});

export const {
  useCreateCredentialMutation,
  useLazyGetCredentialsByTypeQuery,
  useGetCredentialsQuery,
  useUpdateCredentialMutation,
  useDeleteCredentialMutation,
  useGetCredentialQuery,
} = credentialApi;
